import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UsersComponent } from './pages/users/users.component';
import { AccountsComponent } from './pages/accounts/accounts.component';
import { SimpleLabelsComponent } from './pages/simple-labels/simple-labels.component';
import { PalletLabelsComponent } from './pages/pallet-labels/pallet-labels.component';
import { OrdersComponent } from './pages/orders/orders.component';
import { CreateOrderComponent } from './pages/create-order/create-order.component';
import { LoginComponent } from './pages/login/login.component';
import { HomeComponent } from './pages/home/home.component';
import { UnauthorizedComponent } from './pages/unauthorized/unauthorized.component';
import { roleGuard } from './../guard/role.guard';
import { DomainMobileGuard } from './../guard/domain.guard';
import { RoleConstants } from './../domain/role.model';
import { QrScannerV2Component } from './qr-scanner-v2/qr-scanner-v2.component';
import { QrPalletScannerV2Component } from './qr-pallet-scanner-v2/qr-pallet-scanner-v2.component';
import { PalletizeComponent } from './palletize/palletize.component';
import { ArticlesInventoryComponent } from './articles-inventory/articles-inventory.component';
import { ProductCatalogComponent } from './product-catalog/product-catalog.component';
import { PalletsInventoryComponent } from './pallets-inventory/pallets-inventory.component';
import { ScanRedirectPopupComponent } from './scan-redirect-popup/scan-redirect-popup.component';
import { MobileMenuComponent } from './mobile-menu/mobile-menu.component';
import { ArticlesReleaseComponent } from './articles-release/articles-release.component';
import { EditPalletComponent } from './edit-pallet/edit-pallet.component';
import { EditArticleComponent } from './edit-article/edit-article.component';

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'unauthorized', component: UnauthorizedComponent },
  {
    path: 'article-scanner',
    component: QrScannerV2Component,
    canActivate: [roleGuard([RoleConstants.BILD_ADMIN, RoleConstants.BILD_ENCARGADO, RoleConstants.BILD_OPERADOR])],
  },
  {
    path: 'pallet-scanner',
    component: QrPalletScannerV2Component
    , canActivate: [roleGuard([RoleConstants.BILD_ADMIN, RoleConstants.BILD_ENCARGADO, RoleConstants.BILD_OPERADOR])],
  },
  {
    path: 'palletization',
    component: PalletizeComponent,
    canActivate: [roleGuard([RoleConstants.BILD_ADMIN, RoleConstants.BILD_ENCARGADO, RoleConstants.BILD_OPERADOR])],
  },
  {
    path: 'edit-palet',
    component: EditPalletComponent,
    canActivate: [roleGuard([RoleConstants.BILD_ADMIN, RoleConstants.BILD_ENCARGADO, RoleConstants.BILD_OPERADOR])],
  },
  {
    path: 'edit-articles',
    component: EditArticleComponent,
    canActivate: [roleGuard([RoleConstants.BILD_ADMIN, RoleConstants.BILD_ENCARGADO, RoleConstants.BILD_OPERADOR])],
  },
  {
    path: 'articles-release',
    component: ArticlesReleaseComponent,
    canActivate: [roleGuard([RoleConstants.BILD_ADMIN, RoleConstants.BILD_ENCARGADO, RoleConstants.BILD_OPERADOR])],
  },
  {
    path: 'init-scanner/:type',
    component: ScanRedirectPopupComponent,
    canActivate: [roleGuard([RoleConstants.BILD_ADMIN, RoleConstants.BILD_ENCARGADO, RoleConstants.BILD_OPERADOR])],
  },
  {
    path: 'mobile/menu',
    component: MobileMenuComponent,
    canActivate: [roleGuard([RoleConstants.BILD_ADMIN, RoleConstants.BILD_ENCARGADO, RoleConstants.BILD_OPERADOR])],
  },
  {
    path: 'home', component: HomeComponent,
    children: [
      {
        path: 'users',
        canActivate: [DomainMobileGuard, roleGuard([RoleConstants.BILD_ADMIN, RoleConstants.BILD_ENCARGADO])],
        component: UsersComponent
      },
      {
        path: 'accounts',
        canActivate: [DomainMobileGuard, roleGuard([RoleConstants.BILD_ADMIN, RoleConstants.BILD_OPERADOR, RoleConstants.BILD_ENCARGADO, RoleConstants.BILD_VENTAS])],
        component: AccountsComponent
      },
      {
        path: 'simpleLabels',
        canActivate: [DomainMobileGuard, roleGuard([RoleConstants.BILD_ADMIN, RoleConstants.BILD_ENCARGADO])],
        component: SimpleLabelsComponent
      },
      {
        path: 'palletLabels',
        canActivate: [DomainMobileGuard, roleGuard([RoleConstants.BILD_ADMIN, RoleConstants.BILD_OPERADOR, RoleConstants.BILD_ENCARGADO])],
        component: PalletLabelsComponent
      },
      {
        path: 'orders',
        canActivate: [DomainMobileGuard, roleGuard([RoleConstants.BILD_ADMIN, RoleConstants.BILD_OPERADOR, RoleConstants.BILD_ENCARGADO, RoleConstants.BILD_VENTAS, RoleConstants.CLIENTE_ADMIN, RoleConstants.CLIENTE_OPERADOR])],
        component: OrdersComponent
      },
      {
        path: 'order/create',
        canActivate: [DomainMobileGuard, roleGuard([RoleConstants.BILD_ADMIN, RoleConstants.BILD_OPERADOR, RoleConstants.BILD_ENCARGADO, RoleConstants.BILD_VENTAS, RoleConstants.CLIENTE_ADMIN, RoleConstants.CLIENTE_OPERADOR])],
        component: CreateOrderComponent
      },
      {
        path: 'inventory/articles',
        canActivate: [roleGuard([RoleConstants.BILD_ADMIN, RoleConstants.BILD_OPERADOR, RoleConstants.BILD_ENCARGADO, RoleConstants.BILD_VENTAS, RoleConstants.CLIENTE_ADMIN, RoleConstants.CLIENTE_OPERADOR])],
        component: ArticlesInventoryComponent
      },
      {
        path: 'inventory/pallets',
        canActivate: [roleGuard([RoleConstants.BILD_ADMIN, RoleConstants.BILD_OPERADOR, RoleConstants.BILD_ENCARGADO, RoleConstants.BILD_VENTAS, RoleConstants.CLIENTE_ADMIN, RoleConstants.CLIENTE_OPERADOR])],
        component: PalletsInventoryComponent
      },
      {
        path: 'catalog/products',
        canActivate: [roleGuard([RoleConstants.BILD_ADMIN, RoleConstants.BILD_OPERADOR, RoleConstants.BILD_ENCARGADO, RoleConstants.BILD_VENTAS, RoleConstants.CLIENTE_ADMIN, RoleConstants.CLIENTE_OPERADOR])],
        component: ProductCatalogComponent
      },
    ]
  },
  //{ path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: '', redirectTo: '/home/inventory/articles', pathMatch: 'full' }
];

// Validation for Ex Inventory
// canActivate: [roleGuard([RoleConstants.BILD_ADMIN, RoleConstants.BILD_OPERADOR, RoleConstants.BILD_ENCARGADO, RoleConstants.BILD_VENTAS, RoleConstants.CLIENTE_ADMIN, RoleConstants.CLIENTE_OPERADOR])],


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
